import { useContext } from "react";
import { MeetingContext } from "../contexts/MeetingContext";

export const useMeeting = () => useContext(MeetingContext);
